import { render, staticRenderFns } from "./ShowDetailItem.vue?vue&type=template&id=795a57aa"
import script from "./ShowDetailItem.vue?vue&type=script&lang=js"
export * from "./ShowDetailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports